import { memo } from 'react';
import { Box, IconButton } from '@mui/material';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import StarIcon from '@mui/icons-material/Star';
import {
  savedSearchIconButtonStyle,
  getSavedSearchIconStyle,
} from '../../../../SavedSearch/SavedSearchStyles';
import { useSavedSearch } from 'components/SavedSearch/SavedSearchContextProvider';
import { SavedSearchItem } from 'providers/contexts/extensions/SavedSearches';

interface SearchSavedDefaultFieldProps {
  record: SavedSearchItem;
}

/**
 * SearchSavedDefaultField component renders star icon button
 * to allow user to set the row as their saved search default.
 */
export const SearchSavedDefaultField = memo(
  ({ record }: SearchSavedDefaultFieldProps) => {
    const { setSavedSearchOpen, setSearchRefId, defaultSavedSearchState } =
      useSavedSearch();

    const defaultSavedSearchData = defaultSavedSearchState?.defaultSavedSearch;

    return (
      <Box id="advanced-save-search-tooltip-target">
        <IconButton
          data-testid="search-saved-default-field-button"
          aria-label="Set as default saved search"
          size="small"
          sx={savedSearchIconButtonStyle}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            if (!record?.id) {
              console.warn('[SearchSavedDefaultField] No record ID found');
              return;
            }
            setSavedSearchOpen(true);
            setSearchRefId(record?.id);
          }}
        >
          {record?.id === defaultSavedSearchData?.id ? (
            <StarIcon sx={(theme) => getSavedSearchIconStyle(theme, true)} />
          ) : (
            <StarOutlineIcon sx={(theme) => getSavedSearchIconStyle(theme, false)} />
          )}
        </IconButton>
      </Box>
    );
  },
);
SearchSavedDefaultField.displayName = 'SearchSavedDefaultField';

export default SearchSavedDefaultField;
